import React from "react";

const AddBannerSlider = (props) => {
  return <div>AddBannerSlider</div>;
};

export default React.memo(AddBannerSlider);
